import { linkAnchorColor } from '../../../../md/assets/jss/material-dashboard-pro-react';
import facePageStyles from '../views/facePageStyles';
import activityPanelStyles from './activityPanelStyles';

const actionPanelStyles = (theme) => ({
  ...facePageStyles(theme),
  ...activityPanelStyles(theme),

  actionPanel: {
    margin: '20px 0 0',
    padding: 0,
    backgroundColor: '#fff',
  },
  actionPanel_headerTabs: {
    borderBottom: '1px solid #e0e0e0',
    textAlign: 'left',
    display: 'flex',
  },
  actionTab: {
    color: 'rgba(12, 13, 13, 0.64)',
    display: 'inline-block',
    padding: '10px 8px',
    position: 'relative',
    textTransform: 'uppercase',
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '20px',
    // flex: "1 0 auto",
    flex: '1 1 auto',
    textAlign: 'center',
  },
  actionTabSpan: {
    cursor: 'pointer',
  },
  selectedTab: {
    color: '#0c0d0d',
    borderBottom: `2px solid ${linkAnchorColor}`,
  },
});

export default actionPanelStyles;
